document.addEventListener('DOMContentLoaded', () => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const megaMenus = document.querySelectorAll('.js-mega-menu-hover');

  if (!megaMenus.length) return;

  megaMenus.forEach((menu) => {
    let closeTimer;

    const openMenu = () => {
      if (!desktopQuery.matches) return;

      clearTimeout(closeTimer);

      megaMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) {
          otherMenu.removeAttribute('open');
        }
      });

      menu.setAttribute('open', '');
    };

    const closeMenu = () => {
      if (!desktopQuery.matches) return;

      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        menu.removeAttribute('open');
      }, 120);
    };

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', closeMenu);

    const summary = menu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
      });
    }
  });
});